import { useEffect } from "react";
import { ComponentWithChildren, ILogEvent } from "../types";
import PublicApiService from "../../services/PublicApiService";
import OfflineStorage from "../offlineStorage/OfflineStorage";
import { BADGE_EVENTS } from "../enums";
import { useGetMetadataForSync } from "../hooks/useGetMetadataForSync/useGetMetadataForSync";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import DeviceCacheHelper from "../../components/devices/addDevice/helpers/deviceCacheHelper/DeviceCacheHelper";

export const LogSynchronization: ComponentWithChildren = ({ children }) => {
  const { getMetadataForSync } = useGetMetadataForSync();
  const offline = useSelector((state: RootState) => state.metadata.offline);

  const syncBadgeDownloadLogs = async (downloadEvents: ILogEvent["event"][]) => {
    try {
      const { gbsCode } = getMetadataForSync();
      const deviceId = await DeviceCacheHelper.getCachedInstanceId();
      await PublicApiService.logBadgeDownloadedEvent(downloadEvents, gbsCode, deviceId);
      await OfflineStorage.deleteItem(OfflineStorage.getBadgeEventsKey());
    } catch (e) {}
  };

  const syncLogs = async () => {
    const logsFromStore: ILogEvent[] | null = await OfflineStorage.getLogEvents();
    if (logsFromStore?.length !== 0) {
      const downloadEvents = logsFromStore.filter(({ type }) => type === BADGE_EVENTS.DOWNLOAD).map(e => ({ ...e.event }));
      if (downloadEvents.length !== 0) {
        await syncBadgeDownloadLogs(downloadEvents);
      }
    }
  };

  useEffect(() => {
    if (!offline) {
      setTimeout(() => {
        try {
          syncLogs();
        } catch (e) {
          console.error("Error during network sync: ", e);
        }
      }, 8000);
    }
  }, [offline]);

  return <>{children}</>;
};
